<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import NumberField from '../../components/form/number_field.svelte'
  import ToggleField from '../../components/form/toggle_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  // Validation is the server's: each change is checked live by a Precognition request to
  // the real create/update action, and again on Save.
  let { point_source: pointSource, back_url: backUrl } = $props()

  const isEdit = !!pointSource.id
  const url = isEdit ? `/point-sources/${pointSource.id}` : '/point-sources'

  const form = useForm({
    point_source: { name: pointSource.name, points: pointSource.points, active: pointSource.active },
    return_to: backUrl
  }).withPrecognition(isEdit ? 'patch' : 'post', url)
  liveValidate(form, 'point_source')

  const submit = (event) => {
    event.preventDefault()
    if (isEdit) $form.patch(url)
    else $form.post(url)
  }
</script>

<Layout>
  <PageHeader title={isEdit ? 'Edit Point Source' : 'New Point Source'} subtitle="Reusable point rewards awarded to users" />

  <FormLayout onsubmit={submit}>
    <FormSection title="Details">
      <TextField bind:value={$form.point_source.name} label="Name" name="name" error={$form.errors['point_source.name']} required />
      <NumberField bind:value={$form.point_source.points} label="Points" name="points" help="Amount of points to award user from this Point Source" error={$form.errors['point_source.points']} required />
      <ToggleField bind:checked={$form.point_source.active} label="Active" name="active" error={$form.errors['point_source.active']} />

      {#if $form.errors['point_source.base']}<p class="text-sm text-error">{$form.errors['point_source.base']}</p>{/if}
    </FormSection>

    {#snippet footer()}
      <Button href={backUrl} variant="ghost" size="sm">Cancel</Button>
      <SubmitButton processing={$form.processing} full={false} />
    {/snippet}
  </FormLayout>
</Layout>
